// extracted by mini-css-extract-plugin
module.exports = {"container":"_1FreV","main":"_2KwWa","gallery":"_20eN3","col":"_15fKm","left":"_2avXl","right":"_3Mjt4","price":"_1pJVc","sku":"mqJIO","description":"i6adX"};